import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/account/view/license.account.review.mutation.gql"
import type {
  ReviewBillingAccountMutation,
  ReviewBillingAccountMutationVariables,
} from "@/v2-backoffice-client/license/account/view/__types__/license.account.review.mutation"

type Options = MutationHookOptions<
  ReviewBillingAccountMutation,
  ReviewBillingAccountMutationVariables
>

export function useReviewBillingAccountMutation(options?: Options) {
  return useMutation<
    ReviewBillingAccountMutation,
    ReviewBillingAccountMutationVariables
  >(mutation, options)
}
